import i18n from '~/i18n';
import { Form } from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import { contains, trim } from 'ramda';
import validatorjs from 'validatorjs';

class ChannelMailForm extends Form {
  constructor(data, options) {
    super(data, options);
  }

  options() {
    return {
      validateOnInit: false,
      validateOnChange: true,
      validateOnBlur: false,
    };
  }

  /*
    Below we are returning a `plugins` object using the `validatorjs` package
    to enable `DVR` functionalities (Declarative Validation Rules).
  */
  plugins() {
    return {
      dvr: dvr({
        package: validatorjs,
        extend: ({ validator }) => {
          const messages = validator.getMessages('en');
          messages['required_unless.emailTitle'] = i18n.t(
            'form.rule.invalidSpaces',
            '공백 문자를 제외하고 입력해 주세요.'
          );
          messages.max = i18n.t('form.rule.max', ':max자 이하로 입력해 주세요.');
          validator.setMessages('en', messages);
          validator.register('checkNonEmpty', (value) => {
            return !contains(' ', value) || trim(value) !== '';
          });
        },
      }),
    };
  }

  /*
    Return the `fields` as a collection into the `setup()` method
    with a `rules` property for the validation.
  */
  setup() {
    return {
      fields: [
        {
          name: 'emailAddress',
          rules: 'required',
          value: '',
        },
        {
          name: 'domainPart',
          rules: 'required',
          value: '',
        },
        {
          name: 'emailTitle',
          rules: `required_unless:emailTitle,|max:30`, // 메일 제목이 빈 문자열이 아닌경우 공백은 허용 안함
          value: '',
        },
        {
          name: 'emailDescription',
          rules: 'max:100',
          placeholder: i18n.t('mailChannelFormDescriptionPlaceholder', '메일 설명을 입력해 주세요.'),
          value: '',
        },
      ],
    };
  }
}

export default ChannelMailForm;
